import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FornecedorListarComponent } from './fornecedor-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: FornecedorListarComponent }
    ])],
    exports: [RouterModule]
})
export class FornecedorListarRoutingModule { }
